import HistoryWithdrawComponent from '@components/history-withdraw';
import * as React from 'react';

export interface IHistoryWithdrawProps {}

export default function HistoryWithdraw(props: IHistoryWithdrawProps) {
  return <HistoryWithdrawComponent />;
}
